<div *ngIf="entity()?.metrics?.totCountOpened > 0"
     class="d-flex ion-align-items-center text-neutral-400">
    <div class="ts-caption-bold pr-xxs">
        {{ entity()?.metrics?.totCountOpened }}
    </div>
    <ion-icon style="font-size: 16pt;" name="eye"></ion-icon>
</div>
